'use client';
import { setRTLStatus } from '@bybit/rtl-plugin';
import { useEffect } from 'react';

export const RTLList = ['ar-SA'];

export const isRTL = (locale?: string) => {
  if (!locale) return false;
  return RTLList.includes(locale);
};

export const getDirValue = (locale?: string) => {
  const rtlStatus = isRTL(locale);
  setRTLStatus(rtlStatus);
  return rtlStatus ? 'rtl' : 'ltr';
};

export const useRTLListener = (locale?: string) => {
  useEffect(() => {
    document.documentElement.dir = getDirValue(locale);
  }, [locale]);
};
